import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import AventiorLogo from "../../assets/aventior_logo_color_rgb.jpg";
import "./header.scss";
import { useHistory } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import * as acts from "../../redux/auth/actions";
import { useDispatch } from "react-redux";
import ModalEsign from "../Modal/signature/ModalSign";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ProgressBar from "../../components/ProgressBar";
import { action } from "../../constants/action";
var AWS = require("aws-sdk");

export default function Header(props) {
  const dispatch = useDispatch();
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSignPad, setopenSignPad] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(acts.userLogout());
    localStorage.clear();
    history.push("/");
    setAnchorEl(null);
  };

  const handleEsignDialogBoxOpen = () => {
    setLoader(true);
    getSignature();
    setAnchorEl(null);
  };
  const handleEsignDialogBoxClose = () => {
    setopenSignPad(false);
    setAnchorEl(null);
  };
  const handleHome = () => {
    if (localStorage.getItem("userRole") === "pre-processor") {
      history.push("pre-processor-dashboard");
    }
    if (localStorage.getItem("userRole") === "processor") {
      history.push("processor-dashboard");
    }
    if (localStorage.getItem("userRole") === "validator") {
      history.push("validator-dashboard");
    }
  };
  useEffect(() => {}, [openSignPad]);
  const getSignature = () => {
    AWS.config.update({
      accessKeyId: process.env.REACT_APP_ID,
      secretAccessKey: process.env.REACT_APP_KEY,
      // region: process.env.REACT_APP_REGION,
    });
    var s3 = new AWS.S3();

    var params = {
      Bucket: `${process.env.REACT_APP_BUCKET_NAME}`,
      // Key: `${localStorage.getItem("userid")}/e_signature/signature.png`,
      Key: `${process.env.REACT_APP_BUCKET_NAME_ROOT_FOLDER}/e_signature/${localStorage.userid}/signature.png`,
    };

    s3.getObject(params, function (err, data) {
      if (err) {
        setLoader(false);
        setopenSignPad(true);
        // alert(err);
        // that.setState({ loader: false });
      }
      if (data) {
        setTrimmedDataURL(data.Body);
        setLoader(false);
        setopenSignPad(true);
      }
    });
  };

  return (
    <ThemeProvider>
      <Box className="header">
        <AppBar position="static">
          <Toolbar className="toolBar">
            <img
              src={AventiorLogo}
              className="logo"
              onClick={() => handleHome()}
              alt="AventiorLogo"
            />
            <div className="vertical"></div>
            <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
              {action?.LOGO}
            </Typography>

            <Typography variant="subtitle1" margin={1}>
              {localStorage?.userName || "Oscar Thomsen"} (
              {localStorage?.userName
                ? localStorage?.userRole?.charAt(0).toUpperCase() +
                  localStorage?.userRole?.slice(1)
                : "Admin"}
              )
            </Typography>

            <IconButton
              size="medium"
              edge="start"
              // color="inherit"
              aria-label="menu"
              // sx={{ mr: 2 }}
            >
              <MenuIcon
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                className="user-profile-icon"
                //  variant="square"
              />
            </IconButton>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              className="user-profile"
              onClose={(e) => handleCloseMenu(e)}
              MenuListProps={{
                "aria-labelledby": "demo-positioned-button",
              }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              {localStorage.getItem("userRole") === "pre-processor" ||
              localStorage.getItem("userRole") === "processor" ||
              localStorage.getItem("userRole") === "validator" ? (
                <MenuItem onClick={handleEsignDialogBoxOpen}>
                  {action.E_SIGN}
                </MenuItem>
              ) : (
                ""
              )}
              <MenuItem onClick={handleLogout}>{action.LOGOUT}</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </Box>
      {loader === true && <ProgressBar></ProgressBar>}
      {localStorage.getItem("userRole") === "pre-processor" ||
      localStorage.getItem("userRole") === "processor" ||
      localStorage.getItem("userRole") === "validator" ? (
        <ModalEsign
          openSignPad={openSignPad}
          handleEsignDialogBoxClose={handleEsignDialogBoxClose}
          trimmedDataURL={trimmedDataURL}
          // handleEsignDialogBoxClose ={(value) => handleEsignDialogBoxClose (value)}
        ></ModalEsign>
      ) : (
        ""
      )}
    </ThemeProvider>
  );
}
